import { render } from "./EditDoctorView.vue?vue&type=template&id=4a6a895d&ts=true"
import script from "./EditDoctorView.vue?vue&type=script&lang=ts"
export * from "./EditDoctorView.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\RESPALDO 17-01-26 PC\\git\\adminSanatorio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__